import Cookies from 'js-cookie';
import { logWithOffset } from "./logWithOffset";
export function applySplitTesting(cookieNamespace) {
  const cookieId = `splittest_${cookieNamespace}`;


  const cookieData = Cookies.get(cookieId);

  const decisions = (typeof(cookieData) === 'string') ? JSON.parse(cookieData) : {};
  const splitState = {};
  document.querySelectorAll('.checkout-split-test').forEach(x => {
    const splitId = x.dataset.splitId;
    splitState[splitId] = splitState[splitId] || [];
    splitState[splitId].push(x.dataset.splitValue);
  });

  for (let [k,v] of Object.entries(splitState)) {
    decisions[k] = decisions[k] || v[Math.floor(Math.random() * v.length)];
    logWithOffset(`Split Testing id: ${k} value: ${decisions[k]}`);
    document.querySelectorAll(`.checkout-split-test[data-split-id="${k}"][data-split-value="${decisions[k]}"]`).forEach(x => {
      x.style.display="block";
    });
  }

  Cookies.set(cookieId, JSON.stringify(decisions), { expires: 1 });
  return decisions;
}

/*
<html>
  <head>
    <title>AB Spec</title>
    <style>
      .checkout-split-test {
        display: none;
      }
    </style>

  </head>
  <body>
    <div class="checkout-split-test" data-split-id="banner" data-split-value="hello1">
      Hello1
    </div>

    <div class="checkout-split-test" data-split-id="banner" data-split-value="hello2">
      Hello2
    </div>

    <div class="checkout-split-test" data-split-id="banner" data-split-value="hello1">
      Hello3
    </div>

    <div class="checkout-split-test" data-split-id="banner" data-split-value="hello2">
      Hello4
    </div>



  </body>


</html>

*/
